import React from 'react';
import styled from 'styled-components';
import { Release } from "types/release";
import { Cover } from './Cover';
import { ReleaseArtists } from './ReleaseArtists';
import { GenreInfo } from './GenreInfo';
import { CreateReleaseDate } from './CreateReleaseDate';
import { ReleaseCode } from './ReleaseCode';
import { Status } from "./Status";
import { PaginatorPageChangeEvent } from "primereact/paginator";
import { useNavigate } from "react-router-dom";

interface ListViewProps {
  data: Release[];
  currentPage: number;
  pageCount: number;
  total: number;
  onPageChange?: (event: PaginatorPageChangeEvent) => void;
}

export const ListView: React.FC<ListViewProps> = props => {
  const { data } = props;
  const navigate = useNavigate();
  return (
    <Container>
      {data.map((release: Release) => (
        <Card
          key={release.id}
          role="button"
          tabIndex={0}
          onClick={() => navigate(`/releases/${release.id}`)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") navigate(`/releases/${release.id}`);
          }}
        >
          <Cover cover={release.cover_url} height="203px" width="203px" />
          <Middle>
            <ReleaseArtistsWrapper>
              <ReleaseArtists release={release.title} artists={release.artists} />
            </ReleaseArtistsWrapper>
            <GenreInfo genres={release.genres} />
            <CreateReleaseDate createdAt={release.created_at} releaseDate={release.release_date} />
            <ReleaseCode id={release.id} ean={release.ean} />
          </Middle>
          <Right>
            <Status status={release.status} />
          </Right>
        </Card>
      ))}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
`;

const Card = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  border-radius: 20px;
  background: #FFFFFF;
  border: 1px solid #D8D8D8;
  padding: 20px;
  cursor: pointer;

  &:hover {
    border-color: rgba(103, 119, 255, 0.5);
  }

  &:focus-visible {
    outline: 2px solid rgba(103, 119, 255, 0.7);
    outline-offset: 2px;
  }
`;

const Middle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
`;

const ReleaseArtistsWrapper = styled.div`
  margin-bottom: 10px;
`;

// paginator is rendered by parent (`Releases/index.tsx`)
